<template>
  <div class="my-2">
    <template v-if="selectedFlag">
      <div class="cursor-pointer">
        <div class="available-action flex px-4 py-2" @click="printLabels()">
          <feather-icon icon="PrinterIcon" svgClasses="w-4 h-4" class="self-center"/>
          <span class="text-sm ml-2">{{ $t('Print Label') }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select the order you want to print!')}`">
        <div class="cursor-not-allowed">
          <div class="pointer-events-none unavailable-action flex px-4 py-2">
            <feather-icon icon="PrinterIcon" svgClasses="w-4 h-4" class="self-center"/>
            <span class="text-sm ml-2">{{ $t('Print Label') }}</span>
          </div>
        </div>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
  props: ['selected'],
  data () {
    return {
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    printLabels () {
      JsBarcode('.barcode').init()
      window.print()
    }
  }
}
</script>